import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';

import {AuditListComponent} from './audit/audit-list/audit-list.component';
import {AuditUpdateHistoryComponent} from './audit/audit-update-history/audit-update-history.component';
import {AuditAddComponent} from './audit/audit-add/audit-add.component';
import {AuditDetailsComponent} from './audit/audit-details/audit-details.component';
import {AuditListResolver, AuditResolver} from './audit.resolvers';
import { FindingAddComponent } from './finding/finding-add/finding-add.component';
import { FindingListComponent } from './finding/finding-list/finding-list.component';
import { FindingDetailComponent } from './finding/finding-detail/finding-detail.component';
import { CapaAddComponent } from './capa/capa-add/capa-add.component';
import { CapaDetailComponent } from './capa/capa-detail/capa-detail.component';
import { EvidenceListComponent } from './evidence/evidence-list/evidence-list.component';
import { EvidenceApprovalListComponent } from './evidence/evidence-approval-list/evidence-approval-list.component';
import { CapaListComponent } from './capa/capa-list/capa-list.component';
import { CapaUpdateHistoryComponent } from './capa/capa-update-history/capa-update-history.component';
import { EvidenceUpdateHistoryComponent } from './evidence/evidence-update-history/evidence-update-history.component';

const routes: Routes = [
  {
    path: '', 
    component: AuditListComponent, 
    resolve: {audit: AuditListResolver}, 
    pathMatch: 'full'
  },
  {
    path: 'add', 
    component: AuditAddComponent
  },
  {
    path: ':id',
    pathMatch: 'full',
    component: AuditDetailsComponent,
    resolve: {audit: AuditResolver},
  },
  {
    path: ':id/finding/add',
    component: FindingAddComponent,
    resolve: {audit: AuditResolver},
  },
  {
    path: 'all/findings',
    pathMatch: 'full',
    component: FindingListComponent,
  },
  {
    path: ':auditId/finding/:findingId',
    pathMatch: 'full',
    component: FindingDetailComponent,
  },
  {
    path: ':auditId/finding/:findingId/capa/add',
    pathMatch: 'full',
    component: CapaAddComponent,
  },
  {
    path: ':auditId/finding/:findingId/capa/:capaId',
    pathMatch: 'full',
    component: CapaDetailComponent,
  },
  {
    path: ':auditId/finding/:findingId/capaevidence/:capaId',
    pathMatch: 'full',
    component: EvidenceListComponent,
  },
  {
    path: ':auditId/finding/:findingId/capa/:capaId/approval',
    pathMatch: 'full',
    component: EvidenceApprovalListComponent,
  },
  {
    path: 'all/capa',
    pathMatch: 'full',
    component: CapaListComponent,
  },
  {
    path: 'capas/history/:id',
    pathMatch: 'full',
    component: CapaUpdateHistoryComponent,
  },
  {
    path: 'history/:id',
    pathMatch: 'full',
    component: AuditUpdateHistoryComponent,
  },
  {
    path: 'evidence/history/:capaId',
    pathMatch: 'full',
    component: EvidenceUpdateHistoryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuditRoutingModule {}
